import BreadCrumbs from '@/components/atom/BreadCrumbs';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import { zIndex } from '@/constants/zIndex';
import DNSearchBar from '@/design-components/organisms/dnsearch-bar';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';
import { DiseaseEncyclopediaViewModel } from '@/views/disease-encyclopedia/segments/hooks/useDiseaseEncyclopediaViewModel';
import React from 'react';
import 'swiper/css';
import { cn } from '@/utils/style';
import { Button } from 'doctornow-design-system';
import Link from 'next/link';
import DepartmentButton from './DepartmentButton';
import PopularDiseaseEncyclopedia from './PopularDiseaseEncyclopedia';
import PopularDiseaseEncyclopediaSwiper from './PopularDiseaseEncyclopediaSwiper';
import TotalDepartmentButton from './TotalDepartmentButton';

interface Props {
  viewModel: DiseaseEncyclopediaViewModel;
  client: Client;
}

const DiseaseEncyclopediaView = (props: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {props.client.clientType === ClientType.WEB && (
        <BreadCrumbs.Wrapper>
          <BreadCrumbs
            visible
            name='질환백과'
            type='disease_encyclopedia'
            path={`${ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path}`}
          />
        </BreadCrumbs.Wrapper>
      )}

      <h1 className='typography-ui-22sb px-[24px] py-[16px] text-gray-900'>질환백과</h1>

      <div
        className='px-[24px] py-[16px]'
        style={{
          zIndex: zIndex.AppHeader,
          top: props.client.clientType === ClientType.MOBILE_WEB ? '60px' : '0px',
        }}
      >
        <DNSearchBar
          value={props.viewModel.keyword}
          placeholder={'질환 이름 혹은 증상 검색'}
          shouldShowResetButton={!!props.viewModel.keyword}
          onSubmit={props.viewModel.handleSubmit}
          onReset={props.viewModel.handleResetSearchKeyword}
          onChange={props.viewModel.handleChangeSearchKeyword}
        />
      </div>

      <div className='px-[24px] pt-[4px] pb-[32px]'>
        <h2 className='typography-ui-20sb mb-5 text-gray-700'>과목으로 찾기</h2>
        <div
          className={cn(
            'grid grid-rows-2',
            props.client.isMobile ? 'grid-cols-4' : 'grid-cols-7',
            props.client.isMobile ? 'gap-[16px]' : 'gap-[20px]'
          )}
        >
          {props.viewModel.departmentCategories.map((departmentCategory) => (
            <DepartmentButton
              key={departmentCategory.id}
              iconImgSrc={departmentCategory.icon}
              name={departmentCategory.name}
              onClick={props.viewModel.onClickDiseaseEncyclopedia(departmentCategory)}
            />
          ))}
          <TotalDepartmentButton />
        </div>
      </div>

      <div className='h-[16px] bg-gray-30' />

      <div className='pt-[32px] pb-[80px]'>
        <div className='mb-[20px] flex items-center gap-[4px] px-[24px]'>
          <h2 className='typography-ui-20sb text-gray-700'>많이 찾는 질환</h2>
        </div>
        {props.client.isMobile ? (
          <PopularDiseaseEncyclopediaSwiper
            popularDiseaseEncyclopedia={props.viewModel.popularDiseaseEncyclopedia}
            onClick={props.viewModel.handleClickPopularDisease}
          />
        ) : (
          <PopularDiseaseEncyclopedia
            popularDiseaseEncyclopedia={props.viewModel.popularDiseaseEncyclopedia}
            onClick={props.viewModel.handleClickPopularDisease}
          />
        )}
        <div className='flex justify-center px-[24px] pt-[24px]'>
          <Link href={ROUTES.DISEASE_ENCYCLOPEDIA.TOTAL.path}>
            <a>
              <Button buttonStyle='outlined' buttonColor='gray' size='xl' className='w-full'>
                질환 전체 보기
              </Button>
            </a>
          </Link>
        </div>
      </div>
    </TemplateLayout.Wrapper>
  );
};

export default DiseaseEncyclopediaView;
